<template>
  <BaseCheckboxSelector
    v-if="locationsMapped"
    allow-child-selection
    bordered
    color="primary"
    :items="locationsMapped"
    :model-value="selectedLocations"
    @update:model-value="updateModelValue"
  >
    <template #header="{ toggle }">
      <slot
        name="header"
        :toggle="toggle"
      />
    </template>

    <template #footer>
      <slot name="footer" />
    </template>
  </BaseCheckboxSelector>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { track } from "shared/boot/analytics";
import BaseCheckboxSelector from "shared/components/selectors/checkbox/BaseCheckboxSelector.vue";
import useLocations from "shared/composables/useLocations";
import useSourceFilters from "shared/composables/useSourceFilters";

const { selectedLocations, addFilters } = useSourceFilters();

const { topLocations, locationsForParent } = useLocations();

interface Location {
  id: number;
  name: string;
  type?: string;
  children?: Location[];
}

function getChildren(parent: Location): Location[] {
  if (parent.type === "Global") {
    return [];
  }

  return locationsForParent(parent).map((location: Location) => ({
    id: location.id,
    name: location.name,
  }));
}

const locationsMapped = computed<Location[]>(() =>
  topLocations.value.map((location: Location) => {
    const children = getChildren(location);

    return {
      id: location.id,
      name: location.name,
      children,
    };
  })
);

function updateModelValue(locationIds: number[]): void {
  addFilters("location", locationIds);
  track("Add location in Advanced Source Filter");
}
</script>
